// Silent Witness Interview API Service
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://football.pebbledesigns.co.uk/silent-witness/api' 
  : 'https://football.pebbledesigns.co.uk/silent-witness/api'; // Use production API for testing

export const interviewApi = {
  // Test the API connection
  async testConnection() {
    try {
      const response = await fetch(`${API_BASE_URL}/test.php`);
      const data = await response.json();
      return data;
    } catch (error) {

      throw error;
    }
  },

  // Conduct an interview with ChatGPT using character persona
  async conductInterview(interviewData) {
    try {
      const response = await fetch(`${API_BASE_URL}/interview.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(interviewData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      

      
      return data;
    } catch (error) {

      throw error;
    }
  },

  // Build interview context from character data
  buildInterviewContext(character, setting = 'police interview room') {
    if (!character) return 'Standard police interview room setting.';
    
    return `Interviewing ${character.name} in the ${setting}. ${character.role} with connection to victim: ${character.connection_to_victim}. Background: ${character.background}`;
  },

  // Extract persona prompt from character data
  getPersonaPrompt(character) {
    if (!character || !character.persona_prompt) {
      return 'You are being interviewed by police. Respond naturally and stay in character.';
    }
    
    return character.persona_prompt;
  },

  // Build previous questions array from interview log
  buildPreviousQuestions(interviewLog) {
    const questions = [];
    let currentQuestion = null;
    
    for (const entry of interviewLog) {
      if (entry.type === 'question') {
        currentQuestion = { question: entry.content, answer: '' };
      } else if (entry.type === 'response' && currentQuestion) {
        currentQuestion.answer = entry.content;
        questions.push(currentQuestion);
        currentQuestion = null;
      }
    }
    
    return questions;
  }
};

export default interviewApi;
